<template>
  <v-container class="pa-0" fluid>
    <v-card class="px-3 rounded-xl view-holder mx-auto" dark max-width="396" outlined>
      <v-card class="mx-auto mt-2 mb-5 rounded-pill" height="6px" light outlined width="30%"/>

      <div id="div1">
        <div id="div2"/>

        <v-card class="rounded-pill" height="9" light outlined style="margin-top: 6px" width="9"/>
        <v-card class="rounded-pill ms-3" height="14" light outlined style="margin-top: 3px" width="14"/>
      </div>

      <v-card :height="noHeight ? '' : '70vh'" :max-height="noHeight ? '' : 660"
              class="overflow-y-auto rounded-lg no-scroll" flat light>
        <slot name="default"/>
      </v-card>

      <slot name="extension"/>

      <v-card class="rounded-pill mx-auto my-2" height="40" light outlined width="40"/>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "mockUpMain",

  props: {
    noHeight: Boolean
  }
}
</script>

<style scoped>
.view-holder {
  background-color: #979797;
}

.view-wrapper::-webkit-scrollbar {
  display: none;
}

#div1 {
  display: flex;
  justify-content: center;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  height: 28px;
  width: 40%;
  margin: -1px auto 8px;
  perspective: 100px;
  z-index: 4;
}

#div2 {
  position: absolute;
  height: 100%;
  width: 100%;
  top: -3px;
  /*border: thin solid rgba(0, 0, 0, .2);*/
  border-radius: 0 0 16px 16px;
  transform-style: preserve-3d;
  transform: rotateX(-46deg);
  z-index: 0;
  background-color: #979797;
}
</style>